<template>
  <!-- 面包屑 -->
  <div class="bread-crumb">
    <div
      class="path"
      @click="goToPath(currentPath.path)"
    >
      {{currentPath.label}}
    </div>
    <i class="el-icon-caret-right" />
    <div class="video-cate">
      {{ currentCate ? currentCate : $t('global.noCate') }}
    </div>
    <i class="el-icon-caret-right" />
    <div class="video-name">
      {{ currentVideo }}
    </div>

  </div>
</template>

<script>
export default {
  props: ["currentCate", "currentVideo"],
  data() {
    return {
      currentPath: {
        label: this.$t("customer.home"),
        path: "/customer-home",
      },
    };
  },
  methods: {
    goToPath(path) {
      console.log("???");
      this.$router.push(path);
    },
  },
};
</script>

<style scoped lang='scss'>
.bread-crumb {
  display: flex;
  height: 4rem;
  align-items: center;
  i {
    margin: 0 0.8rem;
    color: #999999;
  }
  .path {
    user-select: none;
    &:hover {
      cursor: pointer;
    }
  }
  .video-cate {
    color: #999999;
  }
  .video-name {
    color: #999999;
  }
}
</style>
